import type { FC } from 'react';
import { memo } from 'react';
import TextField from '@mui/material/TextField';

interface ReadOnlyTextFieldProps {
  label: string;
  value: string;
  maxWidth?: number;
}

const ReadOnlyTextField: FC<ReadOnlyTextFieldProps> = memo(({ label, value, maxWidth = 800 }) => (
  <TextField
    label={label}
    value={value}
    fullWidth
    sx={{
      maxWidth,
      '& .MuiOutlinedInput-root': {
        '&': {
          cursor: 'default',
        },
        '&:hover fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
          cursor: 'default',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
          borderWidth: '1px',
        },
      },
    }}
    InputProps={{ readOnly: true }}
    InputLabelProps={{ shrink: true }}
  />
));

ReadOnlyTextField.displayName = 'ReadOnlyTextField';

export default ReadOnlyTextField;
